import { Wrap } from './styles';

import Icon from '@map/components/Icons';

const GridFake = ({ arrayX }) => {
    
  return (
    <Wrap>
        <div>
            <Icon i="map-print-horizontalgridfake"/>
        </div>      
        <div className='coordinates'>
            <div className='coordinates1 border'>
                {arrayX[0]}                
            </div>
            <div className='coordinates2 border'>
                {arrayX[2]}                
            </div>
            <div className='coordinates3 border'>
                {arrayX[3]}                
            </div>
            <div className='coordinates4 border'>
                {arrayX[4]}                
            </div>
            <div className='coordinates5 border'>
                {arrayX[5]}                
            </div>
            <div className='coordinates6 border'>
                {arrayX[6]}                
            </div>
            <div className='coordinates7 border'>
                {arrayX[7]}                
            </div>       
            <div className='coordinates8 border'>
                {arrayX[1]}                
            </div>
        </div>
    </Wrap>
  );
};


export default GridFake;